import type { Item } from "./api.ts";

// The time zone at a point, from @photostructure/tz-lookup's table, loaded with the form that needs it (the booking
// form, Plan for a day), never with the page.
export type Lookup = (lat: number, lng: number) => string;
let lookupLoad: Promise<Lookup | null> | null = null;
export const loadLookup = () => {
  lookupLoad ??= import("@photostructure/tz-lookup").then(
    (m) => m.default as Lookup,
    () => null,
  );
  return lookupLoad;
};

// Where it is, for its time zone: a stay's or a place's spot, a journey's start or end.
export const pointOf = (item: Item, end: boolean) => {
  const at = item.type === "move" ? (end ? item.to : item.from) : item.where;
  return at?.lat !== undefined && at.lng !== undefined ? { lat: at.lat, lng: at.lng } : null;
};

// The zone at a thing's point (its end's, for a journey's arrival), or null without a point or the table.
export function zoneAt(item: Item, lookup: Lookup | null, end = false): string | null {
  const p = pointOf(item, end);
  if (!p || !lookup) return null;
  try {
    return lookup(p.lat, p.lng);
  } catch {
    return null;
  }
}
